import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const LoadingAnimation = ({ dark }) => {
  return (
    <div className='loader-wrapper'>
      <div className={`lds-ellipsis ${dark ? 'lds-ellipsis--dark' : 'lds-ellipsis--light'}`}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

LoadingAnimation.propTypes = {
  dark: PropTypes.bool
};

export default LoadingAnimation;
